import axios from "axios";
import {
  GET_COMPANY_EPISODES,
  GET_COMPANY_EPISODE,
  COMPANY_ERROR,
} from "./types";

// Get employer of week episodes
export const getCompanyEpisodes = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/employerspotlight");

    dispatch({
      type: GET_COMPANY_EPISODES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COMPANY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get recent employer of the week episode
export const getEmployerRecentEpisode = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/employerspotlight/recent`);

    dispatch({
      type: GET_COMPANY_EPISODE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COMPANY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get employer of week episode
export const getCompanyEpisode = (companyname) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/employerspotlight/${companyname}`);

    dispatch({
      type: GET_COMPANY_EPISODE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: COMPANY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
